import userApi from '../../../../../../api/userApi';
import { formatAmount } from '../../../../../../helpers/format';
import { StyledLimitsContainer } from '../PaygUsage/styled';
import {
  StyledContainer,
  StyledUsedTypography,
  StyledTypography,
  StyledTotalTypography,
  StyledLinearProgress,
  StyledLimitsWrapper,
} from './styled';

type Props = {
  apiKey: string;
};

const SubscribedUsage = ({ apiKey }: Props) => {
  const { data } = userApi.useGetAccountCreditsQuery({
    apiKey,
  });

  const { subscriptionCredits = 0, subscriptionCreditsTotal = 0 } = data || {};
  
  const creditsUsed = subscriptionCreditsTotal - subscriptionCredits;

  return (
    <StyledContainer>
      <StyledLimitsContainer>
        <StyledLimitsWrapper>
          <StyledUsedTypography>
            {formatAmount(creditsUsed)}
          </StyledUsedTypography>
          <StyledTypography>credits used</StyledTypography>
        </StyledLimitsWrapper>
        <StyledLimitsWrapper>
          <StyledTotalTypography>
            {formatAmount(subscriptionCreditsTotal)}
          </StyledTotalTypography>
          <StyledTypography>total</StyledTypography>
        </StyledLimitsWrapper>
      </StyledLimitsContainer>
      <StyledLinearProgress
        variant="determinate"
        value={
          subscriptionCreditsTotal > 0
            ? (creditsUsed / subscriptionCreditsTotal) * 100
            : 0
        }
      />
    </StyledContainer>
  );
};

export default SubscribedUsage;
